<template>
  <div
    v-if="show"
    class="overlay d-flex justify-content-center align-items-center"
  >
    <b-spinner variant="secondary" class="spinner"></b-spinner>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { BSpinner } from "bootstrap-vue-next";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped lang="scss">
.overlay {
  position: absolute;
  inset: 0;
  background-color: white;
  opacity: 0.5;
  z-index: 9999999;
}

.spinner {
  width: 3rem;
  height: 3rem;
}
</style>
